import { render } from "./Geral.vue?vue&type=template&id=186c5d41"
import script from "./Geral.vue?vue&type=script&lang=js"
export * from "./Geral.vue?vue&type=script&lang=js"

import "./Geral.vue?vue&type=style&index=0&id=186c5d41&lang=css"

import exportComponent from "F:\\Projetos-Lefisc\\front-end\\front_retfont\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__